<app-loader *ngIf="isLoading"></app-loader>
<ng-container *ngIf="notification">
    <ng-container>
        <div class="view-notification-text px-2">
            <h5 class=" view-notification-text fw-bold mb-2 mt-3">
                {{ "DASHBOARD.NOTIFICATION" | translate }}
            </h5>
        </div>
        <div class="mt-0">
            <div class="d-flex ms-2 mt-4 view-all-button ">
                <button
                    [ngClass]=" AllNotCount === 0 ? 'buttonsClickfocusViewAll opacity-50' : (selectedNotType != 'All') ? 'buttonsClickViewAll' : 'buttonsClickfocusViewAll'"
                    [disabled]="AllNotCount === 0" (click)="selectNotificationType('All');filterNotification('ALL')">{{
                    "MANAGEDEVICE.ALL" |
                    translate }} {{ " ("+ AllNotCount +")" }}
                </button>
                <button class="ms-2"
                    [ngClass]="alertNotCount === 0 ? 'buttonsClickViewAll opacity-50' : selectedNotType != 'Alerts'?'buttonsClickViewAll' : 'buttonsClickfocusViewAll'"
                    [disabled]="alertNotCount === 0"
                    (click)="selectNotificationType('Alerts');filterNotification('ALERT')">{{
                    "DASHBOARD.ALERTS" |
                    translate }} {{ " ("+ alertNotCount +")" }}
                </button>
                <button class="ms-2"
                    [ngClass]="infoNotCount === 0 ? 'buttonsClickViewAll opacity-50' : selectedNotType != 'Information'?'buttonsClickViewAll' : 'buttonsClickfocusViewAll'"
                    [disabled]="infoNotCount === 0"
                    (click)="selectNotificationType('Information');filterNotification('INFO')">{{
                    "DASHBOARD.INFORMATIONNOT" |
                    translate }} {{ " ("+ infoNotCount +")" }}
                </button>
                <div class="right-end px-4">
                    <select id='selectUserType' (change)="enableSaveButton($event)" [value]="selectedNewValue">
                        <option value="All">{{"DASHBOARD.ALL"| translate}}</option>
                        <option value="Today">{{"DASHBOARD.TODAY"| translate}}</option>
                        <option value="Yesterday">{{"DASHBOARD.YESTERDAY"| translate}}</option>
                    </select>
                </div>

            </div>

        </div>


        <div class="notifyb-bar rounded-20 mt-4 ms-2 ">


            <div *ngIf="groupedNotifications.length === 0" class="empty-notification-div text-center text-muted my-5">
                <div class="">
                    <img class="" src="./assets/images/screenEmptyReport.svg" style="width: 80px;" />
                    <p class="mt-2 transferUserName">{{ "DASHBOARD.NOTIFICATIONEMPTY" |translate }}</p>
                </div>
            </div>
            <!-- Loop through each device -->
            <div class="mt-2" *ngIf="groupedNotifications.length > 0">
                <div *ngFor="let device of groupedNotifications; let i = index">
                    <div class="align-items-start mb-1 mt-2">
                        <div class="ms-1 text-start mt-2 mb-5">
                            <!-- Device Name -->
                            <div class="justify-content-between align-items-center ">
                                <div class="fw-bold ms-4 mt-4">{{ device.date }} {{'('+ device.notifications.length
                                    +')'}}</div>
                            </div>

                            <!-- Loop through each notification of this device -->
                            <div *ngFor="let notify of device.notifications"
                                class="ms-xl-3 ps-1 mt-1 notification-item border-bottom mb-2"
                                (click)="!notify.viewTime && markAsRead(notify)"
                                [ngClass]="{'border-bottom': i !== groupedNotifications.length-1}">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="fw-bold notification-device-name-text">
                                        <span
                                            *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='ALERT'">
                                            <img src="../../../assets/images/Desktop_alert.png" alt="Laptop with alert"
                                                class="ms-0 me-0 mt-0 pt-0 pb-1" />
                                        </span>

                                        <!-- When SYSTEM and alerts is false -->
                                        <span
                                            *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='INFO'">
                                            <img src="../../../assets/images/Laptop.png" alt="Laptop"
                                                class="ms-0 me-0 mt-0 pt-0 pb-1" />
                                        </span>

                                        <span
                                            *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='ALERT'">
                                            <img src="../../../assets/images/mobile_alert.png" alt="Mobile with alert"
                                                class="ms-1 me-1 mt-0 pt-0 pb-1" />
                                        </span>
                                        <span
                                            *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='INFO'">
                                            <img src="../../../assets/images/Rectangle 83.png" alt="Mobile"
                                                class="ms-1 me-1 mt-0 pt-0 pb-1" />
                                        </span>
                                        {{ notify.deviceName }}
                                        <span
                                            *ngIf="notify.notificationType === 'EXPIRY' || notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                                            <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRING_SOON'">
                                                - {{ 'NOTIFICATION.RENEW_LICENSE' | translate }}
                                            </span>
                                            <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRED'">
                                                - {{ 'NOTIFICATION.LICENSE_EXPIRED' | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="notification-message-text px-4">
                                        {{ notify.notTime }}
                                        <span
                                            *ngIf="!notify.viewTime && notify.notificationType != 'EXPIRY' && notify.systemNotificationType != 'EXPIRY_NOTIFICATION'"
                                            (click)="markAsRead(notify)" title="Mark as read"
                                            class="ms-2  rounded-circle dot-indicator cursor-pointer">
                                        </span>
                                    </div>
                                </div>
                                <div class=" mt-2 align-items-center justify-content-between">
                                    <div class="me-2 ms-xl-4 notification-message-text">
                                        {{ getNotificationMessage(notify) }}
                                    </div>
                                    <div *ngIf="notify.actionablePrompt === true" class="mt-2 ">
                                        <div *ngIf="notify.notificationType === 'EXPIRY'">
                                            <button
                                                class=" ms-4 bg-orgclr submit-btn-renew right-end  renew-btn  right-end mb-0 font-700-12 renew-notification-btn"
                                                (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                                                "LICENSESUMMARY.RENEW" |
                                                translate }}</button>
                                        </div>

                                        <div *ngIf="notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                                            <button
                                                class=" ms-4 bg-orgclr submit-btn-renew right-end renew-btn  right-end mb-0 font-700-12 renew-notification-btn"
                                                (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                                                "LICENSESUMMARY.RENEW" |
                                                translate }}</button>
                                        </div>
                                    </div>

                                </div>
                                <!-- Setiing Failure Case : Send a Request Button -->
                                <div class="mt-2"
                                    *ngIf="notify.systemNotificationType === 'SETTING_FAILURE' || notify.notificationType == 'SETTING_FAILURE'">
                                    <button
                                        class="ms-4 bg-orgclr submit-btn-renew  renew-btn  right-end mb-0 font-700-12"
                                        (click)="openSendControlPopup(notify.deviceId,notify.settingType,notify.deviceType,notify.deviceName)">{{
                                        "MANAGEDEVICE.ACTNOW" |
                                        translate }}</button>
                                </div>
                                <!-- <div class="text-muted small">
                    {{ notify.time ? (notify.time | date: 'medium') : '' }}
                  </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="modal" id="renewPopup" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered ">
            <ng-container>
                <div
                    class="modal-content text-center border-none changeWidthHeight overflow-hidden rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
                    <div class="mt-3">
                        <img src="./assets/images/not secure.png" alt="" class="mx-auto" />
                    </div>
                    <h5 class="fw-bold mt-1 mb-2">
                        {{ "LICENSESUMMARY.RENEWPOPUP" | translate }}
                    </h5>
                    <p class="text-sm p-xl-2">
                        {{ "LICENSESUMMARY.RENEWDESC" | translate }}
                    </p>
                    <div class="text-center mb-4 mt-1 d-flex justify-content-center">
                        <div class="me-3">
                            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
                                {{ "LICENSESUMMARY.OK" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<!-- Multiple controls stopped working! Popup -->

<div class="modal" id="controlRequestPopup" data-bs-backdrop="static">
    <div
        class="modal-dialog opt-popup relative w-auto pointer-events-none actOncontrolPopupWidth modal-dialog-centered">
        <div
            class="modal-content border-none rounded-25 shadow-lg actOncontrolPopupWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
            <!-- Modal Header -->
            <div class="mt-0 actOncontrolPopupWidth" *ngIf="requestTypes.split(',').length > 1">
                <h4>
                    <span class="text-transform-none" title> {{ "DASHBOARD.MULTIPLECONTROLSTOPPEDWORK" | translate
                        }}</span>
                </h4>
            </div>

            <div class="mt-0 actOncontrolPopupWidth" *ngIf="!(requestTypes.split(',').length > 1)">
                <h4 class="popup-heading-wrapper">
                    <span class="popup-heading" title> {{ "DASHBOARD."+requestTypes.trim() | translate }} {{
                        "DASHBOARD.HASSTOPPEDWORKING"
                        |
                        translate }}</span>
                </h4>
            </div>

            <!-- Modal body -->
            <div class="mt-3 device-control-popup">
                <div class="Username">
                    <span><img src="./assets/images/Warning.png" alt="" class="" /></span>
                    <span *ngFor="let requestType of requestTypes.split(',');let i = index"> {{
                        "DASHBOARD."+requestType.trim() | translate
                        }} <span *ngIf="i != requestTypes.split(',').length -1">{{ ',' }}</span>
                    </span>
                    {{"DASHBOARD.NOLONGERACTIVE"
                    |
                    translate}} {{ cmdfailedDeviceName }} {{ "DASHBOARD.EXMARK" | translate}}
                </div>
            </div>
            <div class="mt-4 mb-3 send-ctrl-request-width border-secondary-subtle">
                <div class="mt-3 settings-security-feature">
                    <span> {{ "DASHBOARD.PREVIOUSECMDEXPIRE" | translate }} </span>
                </div>
                <div class="mt-2 settings-security-feature">
                    <span> {{ "DASHBOARD.SENDREQUESTTOUSER" | translate }} </span>
                </div>
                <div>
                    <button class="mt-3 mb-1 bg-orgclr w-auto submit-btn" (click)="sendCommands()">{{
                        "DASHBOARD.SENDAREQUEST" |
                        translate }}</button>
                </div>
                <div class="mt-2 settings-security-feature">
                    <span><img src="./assets/images/NoteInfoIcon.svg" alt="" class="pb-1" /></span>
                    <span> {{ "DASHBOARD.MAKESUREINTERNET" | translate }} </span>
                </div>
            </div>
            <div class="cross-arrow-pos">
                <span (click)="hideSendControlPopup()"><img src="./assets/images/otpCancel.svg" alt=""
                        class="ms-xl-4" /></span>

            </div>
        </div>
    </div>
</div>